import { AccessoryType } from './enums/accessory-type';
export class Accessory {
    id: number;
    name = '';
    urlPhoto = '';
    accessoryType: AccessoryType;
}
